import React from 'react';

import { UserListFiltersProvider, UserListFilterMenu } from '@vlabs/monokit/entities/users/filters';
import { SearchUsersByProvider } from '@vlabs/monokit/features/point/search-users-by';
import type { GetUsersParams } from '@vlabs/api/artemy/model';
import { FilterMenuProvider } from '@vlabs/monokit/shared/ui/filter-menu';
import { Page, PageContent, PageFilters } from '@vlabs/monokit/shared/ui/page';
import { UserListTableViewer } from '@vlabs/monokit/widgets/users/user-list-table-viewer/UserListTableViewer';
import { DEFAULT_PAGE_SIZE } from '@vlabs/uikit/constants';

import { UserListPageHeader } from './header/UserListPageHeader';

const defaultFiltersValue: GetUsersParams = {
  sort: 'full_name',
  order: 'desc',
  page: 1,
  page_size: DEFAULT_PAGE_SIZE,
};

function UserListPage(): React.JSX.Element {
  return (
    <Page>
      <SearchUsersByProvider>
        <FilterMenuProvider>
          <UserListFiltersProvider initialData={defaultFiltersValue}>
            <PageContent>
              <UserListPageHeader />
              <UserListTableViewer />
            </PageContent>
            <PageFilters>
              <UserListFilterMenu />
            </PageFilters>
          </UserListFiltersProvider>
        </FilterMenuProvider>
      </SearchUsersByProvider>
    </Page>
  );
}

export { UserListPage };
